import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/register";

export default class Register extends Page {
  title = "register";

  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Sign Up")} | ${this.ucfirst("window-title")}`
    );
  }
}
